<template>
  <div>
    <div class="eu-flex">
      <div class="eu-flex-item eu-basis_12 eu-basis_8_md">
        <LinkExpiration @formIsValid="expirationFormValidation" />
        <Identification @formIsValid="identificationFormValidation" />
      </div>
      <div class="eu-flex-item eu-basis_12 eu-basis_4_md">
        <Summary />
      </div>
    </div>
    <div class="el-section">
      <div class="eu-display_flex">
        <button
          class="emd-btn _color_secondary _type_text _block_mobile"
          @click="goBack"
        >
          <i class="uil uil-angle-left"></i>
          {{ $t("back") }}
        </button>
        <button
          class="emd-btn _color_secondary _block_mobile eu-ml_auto"
          @click="next"
        >
          {{ $t("next") }}
          <i class="uil uil-angle-right"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Identification from './Link/Identification.vue'
import LinkExpiration from './Link/LinkExpiration.vue'
import Summary from '../../components/project/Summary/Summary.vue'

export default {
  name: 'Link',
  components: {
    Identification,
    LinkExpiration,
    Summary
  },
  data () {
    return {
      expirationFormIsValid: false,
      identificationFormIsValid: false
    }
  },
  computed: {
    paymentLinkData () {
      return this.$store.getters.paymentLinkData
    },
    routesWizard () {
      return this.$store.getters.routesWizard
    },
    showFeedbacks: {
      get () {
        return this.$store.getters.showFeedbacks
      },
      set (newValue) {
        this.$store.dispatch('SHOW_FEEDBACK_STATUS', newValue)
      }
    }
  },
  methods: {
    scrollToTop () {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' })
    },
    expirationFormValidation (value) {
      this.expirationFormIsValid = value
      if (!this.expirationFormIsValid) this.showFeedbacks.status = false
    },
    identificationFormValidation (value) {
      this.identificationFormIsValid = value
      if (!this.identificationFormIsValid) this.showFeedbacks.status = false
    },
    goBack () {
      this.$store.dispatch('CHANGE_STATUS', 'products-services')
      this.$router.push({ name: 'PaymentLink' })
    },
    next () {
      this.scrollToTop()
      if (
        (this.expirationFormIsValid &&
          this.paymentLinkData.customerInformation) ||
        this.identificationFormIsValid
      ) {
        this.showFeedbacks.status = true
      } else {
        this.routesWizard = this.routesWizard.map((item) => {
          if (item.path === 'payment-methods') item.permission = true
          return item
        })
        this.$store.dispatch('CHANGE_STATUS', 'payment-methods')
        this.$router.push({ path: 'payment-methods' })
      }
    }
  }
}
</script>

<i18n>
{
  "pt-BR": {
    "back": "Voltar",
    "next": "Avançar"
  },
  "en-US": {
    "back": "Back",
    "next": "Next"
  }
}
</i18n>
